import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import {
  Button,
} from 'src/components/Component';

import DataTable from 'src/components/data-table';
import {useSelector} from 'react-redux';
import API_ROUTES from 'src/config/api';
import UserAddModal from "./modal/add-user";
import moment from "moment";
import {STATUS_TYPES_OBJECT, IMPORTED} from "src/constants/user";
import ActivateUser from "./components/activate-user";
import PiiObfuscator from "src/components/pii-obfuscator";

const RowFormatter = ({item}) => {
  return (
    <tr key={item.id} className="tb-tnx-item">
      <td>
        <strong className="date"><PiiObfuscator type="customer_name">{ item.first_name } {item.last_name}</PiiObfuscator></strong>
      </td>
      <td>
        <span className="date"><PiiObfuscator type="email">{item.email}</PiiObfuscator></span>
      </td>
      <td>
        <span>{ moment(item.created_at).format('Do MMMM YYYY, h:mm:ss a') }</span>
      </td>
      <td className="text-center">
        <span>{STATUS_TYPES_OBJECT[item.status]}</span>
      </td>
      <td className="text-center">
        { item.status === IMPORTED && (
          <ActivateUser user={item} />
        )}
        { item.status !== IMPORTED && (
          <Link to={`/users/${item.id}`}>
            <Button className="border-violet-800 bg-white text-violet-800 text-xs hover:bg-slate-800 hover:border-slate-800">
              Set Permissions
            </Button>
          </Link>
        )}
      </td>
    </tr>
  );
}

const PageOptions = ({triggerReload}) => (
  <ul className="nk-block-tools g-3">
    <UserAddModal refreshUsers={triggerReload} />
  </ul>
);

const TableHeaders = () => (
  <React.Fragment>
    <tr className="tb-tnx-head">
      <th>
        <strong>Name</strong>
      </th>
      <th>
        <span>Email</span>
      </th>
      <th>
        <span>User Since</span>
      </th>
      <th className="text-center">
        <span>Status</span>
      </th>
      <th>
        <span>{' '}</span>
      </th>
    </tr>
  </React.Fragment>
);

const Users = () => {
  const { organisation } = useSelector((state) => state);
  const [ endpoint, setEndpoint ] = useState(API_ROUTES.user['organisation:users'](organisation.organisation));

  useEffect(() => {
    setEndpoint(API_ROUTES.user['organisation:users']());
  }, [organisation.organisation]);

  return (
    <DataTable
      title="Users"
      largeHeading={true}
      columnCount={5}
      TableHeaders={TableHeaders}
      RowFormatter={RowFormatter}
      PageOptions={PageOptions}
      endpoint={endpoint}
      noHeader={true}
      searchPlaceholder="Name or email"
    />
  );
};

export default Users;
